<template>
  <div>
    <div
      v-if="!edit && msg.data.type != 'textMsg'"
      class="wg-row wg-p-xs-20"
      style="margin-bottom: 10px"
    >
      <div class="wg-row" style="align-items: center">
        <input
          id="personal-check"
          type="radio"
          :value="1"
          style="display: none"
          v-model="personal"
        />
        <label class="label-input-radio" for="personal-check">{{
          personal ? "✔" : ""
        }}</label>
        <div class="com-anm22-app-text-l" style="margin: 0 5px">
          {{ $anm22.strLang(lang, "Sent", "Inviato") }}
        </div>
        <div class="com-anm22-horizontal-div" style="width: 20px"></div>
        <input
          id="received-check"
          type="radio"
          :value="0"
          style="display: none"
          v-model="personal"
        />
        <label class="label-input-radio" for="received-check">{{
          !personal ? "✔" : ""
        }}</label>
        <div class="com-anm22-app-text-l" style="margin: 0 5px">
          {{ $anm22.strLang(lang, "Received", "Ricevuto") }}
        </div>
      </div>
    </div>
    <!-- Tipo di elemento -->
    <div class="wg-row" style="margin-bottom: 20px">
      <div
        v-for="(type, index) in types.filter(t=> edit ? t.id != 'reminder' : t)"
        :key="'type-' + index"
        :class="['type-icon-div', type.id === msg.data.type ? 'selected' : '']"
        @click="msg.data.type = type.id"
      >
        <img
          class="type-icon"
          :style="{ backgroundColor: type.bgColor }"
          :src="$anm22.icons.getWorldIcon(type.icon)"
        />
      </div>
    </div>
    <div class="wg-row" style="margin-bottom: 10px">
      <div class="wg-col wg-xs-12 wg-sm-5 wg-p-xs-20">
        <template v-if="msg.data.type === 'call'">
          <!-- Piattaforma -->
          <!-- Da -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "From", "Da") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.from"
              />
            </div>
          </div>
          <!-- A -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "To", "A") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.to"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Outcome", "Esito") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select class="com-anm22-app-select" v-model="callOutcome">
                <option
                    v-for="(o, index) in callOutcomes"
                    :key="'o-' + index"
                    :value="o.id"
                > {{o.label}}</option>
              </select>
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Channel", "Canale") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select class="com-anm22-app-select" v-model="category">
                <option value="other">
                  {{ $anm22.strLang(lang, "Not specified", "Non specificato") }}
                </option>
                <option
                  v-for="(c, index) in categories.filter(c=>c.type.includes('call'))"
                  :key="'category-' + index"
                  :value="c.id"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <!-- Durata -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Duration", "Durata") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="'hh:mm'"
                :value="duration"
                @focus="durationToExpr"
                @blur="parseDuration($event.target.value)"
              />
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'msg'">
          <!-- Da -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "From", "Da") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.from"
              />
            </div>
          </div>
          <!-- A -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "To", "A") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.to"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Channel", "Canale") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select class="com-anm22-app-select" v-model="category">
                <option value="other">
                  {{ $anm22.strLang(lang, "Not specified", "Non specificato") }}
                </option>
                <option
                  v-for="(c, index) in categories.filter(c=>c.type.includes('msg'))"
                  :key="'category-' + index"
                  :value="c.id"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <!-- OGGETTO -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Subject", "Oggetto") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Subject', 'Oggetto')"
                v-model="msg.data.subject"
              />
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'meeting'">
          <!-- Partecipanti -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Attending", "Partecipanti") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                v-model="msg.data.participants"
              />
            </div>
          </div>
          <!-- Luogo -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Location", "Luogo") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                v-model="msg.data.location"
              />
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <!-- Durata -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Duration", "Durata") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="'hh:mm'"
                :value="duration"
                @focus="durationToExpr"
                @blur="parseDuration($event.target.value)"
              />
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'reminder'">
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Name", "Nome") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                v-model="msg.data.name"
              />
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
        </template>
      </div>
      <div
        :class="[
          'wg-col',
          'wg-xs-12',
          'wg-p-xs-20',
          msg.data.type == 'textMsg' ? 'wg-sm-8' : 'wg-sm-7',
        ]"
      >
        <div class="com-anm22-app-text-m" style="margin-bottom: 5px">
          {{
            msg.data.type === "msg" || msg.data.type == "textMsg"
              ? $anm22.strLang(lang, "Text", "Testo")
              : $anm22.strLang(lang, "Description", "Descrizione")
          }}
        </div>
        <textarea
          :class="['description', msg.data.type == 'textMsg' ? 'msg-text' : '']"
          v-model="description"
        ></textarea>
      </div>
    </div>
    <div v-if="edit" class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Last edit", "Ultima modifica ") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height: 10px"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ lastEditDate + " " + lastEditUser }}
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <div class="wg-row">
      <input
        type="button"
        class="small"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="sendMsg"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [String, Number],
    edit: {
      type: Boolean,
      default: false
    },
    msgRef: {
      type: Object,
      default: function () {
        return {
          data: {
            text: "",
            description: "",
            type: "textMsg",
            contentType: "plain"
          },
          ts: this.$moment().unix()
        };
      }
    }
  },
  data() {
    return {
      callOutcome:"replied",
      types: [
        {
          id: "call",
          icon: "phoneWhite",
          bgColor: "orange"
        },
        {
          id: "msg",
          icon: "chatWhite",
          bgColor: "#0aabf4"
        },
        {
          id: "meeting",
          icon: "placeWhite",
          bgColor: "red"
        },
        {
          id: "reminder",
          icon: "reminderWhite",
          bgColor: "#777777"
        }
      ],
      category: "other",
      msg: {
        ...this.msgRef
      },
      personal: 1,
      duration: ""
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user
    }),
    callOutcomes() {
      return [
        {
          id:'replied',
          label: this.$anm22.strLang(this.lang, "Replied", "Risposto") 
        },
        {
          id:'notreplied',
          label: this.$anm22.strLang(this.lang, "Not replied", "Non risposto") 
        },
        {
          id:'notexist',
          label: this.$anm22.strLang(this.lang, "Number not existing", "Numero non esistente") 
        }
      ]
    },
    categories() {
      return [
        {
          id:'whatsapp',
          label:'Whatsapp',
          type: ['msg']
        },
        {
          id:'fb',
          label:'Facebook',
          type:['msg']
        },
        {
          id:'messenger',
          label:'Messenger',
          type:['msg','call']
        },
        {
          id:'zoom',
          label:'Zoom',
          type:['msg','call']
        },
        {
          id:'discord',
          label:'Discord',
          type:['msg','call']
        },
        {
          id:'sms',
          label:'Sms',
          type:['msg']
        },
        {
          id:'email',
          label:'Email',
          type:['msg']
        },
        {
          id:'ig',
          label:'Instagram',
          type:['msg']
        },
        {
          id:'hang',
          label:'Hangouts',
          type:['msg','call']
        },
        {
          id:'skype',
          label:'Skype',
          type:['msg','call']
        },
        {
          id:'teams',
          label:'Microsoft Teams',
          type:['msg','call']
        },
        {
          id:'linkedin',
          label:'Linkedin',
          type:['msg']
        },
        {
          id:'twitter',
          label:'X',
          type:['msg']
        },
        {
          id:'slack',
          label:'Slack',
          type:['msg','call']
        },
        {
          id:'meet',
          label:'Google Meet',
          type:['msg','call']
        }
      ]
    },
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    board() {
      return this.$store.getters["messageChannels/get"](this.project.board);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.msg.data.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.msg.data.lastUpdate
        ? this.$moment.unix(this.msg.data.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    msgDate: {
      get() {
        if (this.msg.ts) {
          return this.$moment.unix(this.msg.ts).format("YYYY-MM-DD");
        } else {
          return "";
        }
      },
      set(newDate) {
        const toParse = (newDate + " " + this.msgTime).trim();
        let ts = Number(this.$moment(toParse).utc().format("X"));
        if (isNaN(ts)) {
          this.$set(this.msg, "ts", "");
        } else if (ts) {
          this.$set(this.msg, "ts", ts);
        }
      }
    },
    msgTime: {
      get() {
        if (this.msg.ts) {
          return this.$moment.unix(this.msg.ts).format("HH:mm");
        } else {
          return "";
        }
      },
      set(newTime) {
        const toParse = (this.msgDate + " " + newTime).trim();
        let ts = Number(this.$moment(toParse).utc().format("X"));
        if (isNaN(ts)) {
          this.$set(this.msg, "ts", "");
        } else if (ts) {
          this.$set(this.msg, "ts", ts);
        }
      }
    },
    description: {
      get() {
        return this.msg.data.type === "msg" || this.msg.data.type == "textMsg"
          ? this.msg.data.text
          : this.msg.data.description;
      },
      set(newVal) {
        if (this.msg.data.type === "msg" || this.msg.data.type == "textMsg") {
          this.msg.data.text = newVal;
        } else {
          this.msg.data.description = newVal;
        }
      }
    }
  },
  methods: {
    async sendMsg() {
      const mode = this.edit ? "edit" : "new";
      if (this.msg.data.type == "textMsg") {
        this.personal = 1;
        this.msg.ts = this.$moment().unix();
      }
      //Tipo risposta
      this.msg.data.callResponse = this.callOutcome;
      this.msg.data.lastUser = this.user.idWorldUser;
      this.msg.data.lastUpdate = this.$moment().unix();
      if (mode === "new") {
        this.msg.idWorldMessage = this.msg.dbKey = this.$anm22.genLocalId();
      }
      let categoryObj = this.categories.find((c) => c.id == this.category);
      if (categoryObj && categoryObj.type.includes(this.msg.data.type)) {
        this.msg.data.category = this.category;
      } else {
        this.msg.data.category = "other";
      }
      try {
        if (mode == 'edit' && !Number.isInteger(this.msg.idWorldMessage)) {
          throw new Error("continue offline...");
        }
        const response = await this.$http
        .post("project/sendMessage", {
          projectId: this.project.idWorldProject,
          msg: this.msg,
          user: this.personal == 1 ? this.user.idWorldUser : ""
        });
        if (response && response.data) {
           await Promise.all([
              this.$store.dispatch("messages/update", {
                vlf: this.$vlf("messages"),
                objs: [response.data.msg]
              }),
              this.$store.dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: [response.data.event]
              }),
            ]);
        } else {
          await Promise.resolve();
        }
      } catch(e) {
        if (mode == 'new') {
          //Se è un nuovo feed creo il mio oggetto messaggio
          this.msg.user = this.personal == 1 ? this.user.idWorldUser : "";
          this.msg.channel = this.project.board;
          this.msg.createdBy = this.user.idWorldUser;
        }
        await Promise.all([
          this.$store.dispatch("messages/update", {
            vlf: this.$vlf("messages"),
            objs: [this.msg]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldMessage",
            _table: "messages",
            mode: mode,
            type: "obj",
            obj: this.msg
          }),
        ]);
      } finally {
        this.$anm22.eventBus.$emit("wg-modal-close");
      }
    },
    parseDuration(string) {
      //Parsing della stringa per settare la durata
      const regex = /\d*([:. ][0-5]?\d)?([:. ][0-5]?\d)?/;
      if (regex.test(string)) {
        let hours = 0,
          minutes = 0;
        let parts = [];
        if (string.includes(":")) {
          parts = string.split(":");
          hours = parts[0];
          minutes = parts[1];
        } else if (string.includes(".")) {
          parts = string.split(".");
          hours = parts[0];
          minutes = parts[1];
        } else if (string.includes(" ")) {
          parts = string.split(" ");
          hours = parts[0];
          minutes = parts[1];
        } else {
          hours = string;
        }
        const result = Number(hours * 3600 + minutes * 60);
        this.msg.data.duration = result;
        this.duration = this.formatDuration(result);
      } else {
        console.log("error in parsing");
        return null;
      }
    },
    formatDuration(seconds) {
      const moment = this.$moment.utc(
        this.$moment.duration(seconds, "seconds").asMilliseconds()
      );
      const format = [
        moment.hours() !== 0 ? "H [h]" : "",
        moment.minutes() !== 0 ? "m [min]" : "",
        moment.seconds() !== 0 ? "s [s]" : "",
      ].join(" ");
      return moment.format(format);
    },
    durationToExpr() {
      this.duration = this.msg.data.duration
        ? Math.floor(this.msg.data.duration / 3600) +
          ":" +
          Math.floor((this.msg.data.duration % 3600) / 60)
        : "";
    }
  },
  created() {
    if (this.msg.data.category) {
      this.category = this.msg.data.category;
    } else if (!this.msg.data.category || this.msg.data.category == "") {
      this.category = "other";
    }
    if(this.msg.data.callResponse && this.msg.data.callResponse != '') {
      this.callOutcome = this.msg.data.callResponse;
    }
    if (this.msg.data.duration) {
      this.durationToExpr();
      this.parseDuration(this.duration);
    }
    //Se è un nuovo feed allora faccio scegliere la tipologia 'Nota semplice'
    if (!this.edit) {
      this.types.unshift({
        id: "textMsg",
        icon: "textMsg",
        bgColor: "rgb(136, 237, 124)"
      });
    }
    // if (!this.msg.data.type) {
    //   this.msg.data.type = "textMsg";
    // }
  }
};
</script>

<style lang="scss" scoped>
.type-icon-div {
  cursor: pointer;
  padding: 5px;
  margin: 0 10px;
  border-bottom: 2px solid #fff;
  &:hover {
    border-bottom: 2px solid #ddd;
  }
  &.selected {
    border-bottom: 2px solid rgb(136, 237, 124);
  }
}
.type-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 5px;
}
.description {
  margin: 0;
  max-width: none;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 10px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
</style>
